// @ts-check
import React from 'react';

import hostingDetailsAlsowith from 'pages/servers/details/hostingDetailsAlsowith';
import useAssetDetails from 'modules/queries/asset/useDetails';
import ServerSpecsCard from './ServerSpecsCard';

/**
 * @param {import('react').ComponentProps<typeof ServerSpecsCard> & {
 *   uniqId: string
 *   showCancellationSection?: boolean
 * }} props
 * */
const HookedServerSpecsCard = ({
	uniqId,
	showCancellationSection,
	...rest
}) => {
	const enabled = Boolean(uniqId);

	const { data: assetDetails, isLoading } = useAssetDetails(
		{
			uniq_id: uniqId,
			alsowith: hostingDetailsAlsowith,
		},
		{ enabled },
	);

	const {
		cpu,
		displayType,
		domain = '',
		ip,
		ramFormatted,
		template,
		cycle,
	} = assetDetails || {};

	const { os_name: osName, os_version: osVersion } = template || {};
	return (
		<ServerSpecsCard
			cpu={cpu}
			displayType={displayType}
			domain={domain}
			ip={ip}
			osName={osName}
			osVersion={osVersion}
			ramFormatted={ramFormatted}
			isLoading={isLoading && enabled}
			billingCycle={cycle}
			showCancellationSection
			{...rest} // allow overriding the fetched data
		/>
	);
};

export default HookedServerSpecsCard;
